







import { Component, Vue } from 'vue-property-decorator'

import store from '../store'
import axios from 'axios'
import { createUser } from '@/api/user'

@Component({
  name: 'SettingsUsers',
  components: {}
})
export default class extends Vue {
  created() {
    //
  }
  async createUser() {
    await createUser('demo@user.de', '$2Z6bus@Dt#t&NW', 'Demo', 'User')
  }
}
